'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dNot$002dScaled$002dReason$0024$0024anon$00241 from "./mealorama.-Not-Scaled-Reason$$anon$1.js";
var $p;
function $s_Lmealorama_NotScaledReason$__NoServingCount__Lmealorama_NotScaledReason() {
  $m_Lmealorama_NotScaledReason$();
  return $t_Lmealorama_NotScaledReason$__NoServingCount;
}
export { $s_Lmealorama_NotScaledReason$__NoServingCount__Lmealorama_NotScaledReason as $s_Lmealorama_NotScaledReason$__NoServingCount__Lmealorama_NotScaledReason };
function $s_Lmealorama_NotScaledReason$__InvalidTargetServings__Lmealorama_NotScaledReason() {
  $m_Lmealorama_NotScaledReason$();
  return $t_Lmealorama_NotScaledReason$__InvalidTargetServings;
}
export { $s_Lmealorama_NotScaledReason$__InvalidTargetServings__Lmealorama_NotScaledReason as $s_Lmealorama_NotScaledReason$__InvalidTargetServings__Lmealorama_NotScaledReason };
function $s_Lmealorama_NotScaledReason$__AlreadyThatSize__Lmealorama_NotScaledReason() {
  $m_Lmealorama_NotScaledReason$();
  return $t_Lmealorama_NotScaledReason$__AlreadyThatSize;
}
export { $s_Lmealorama_NotScaledReason$__AlreadyThatSize__Lmealorama_NotScaledReason as $s_Lmealorama_NotScaledReason$__AlreadyThatSize__Lmealorama_NotScaledReason };
/** @constructor */
function $c_Lmealorama_NotScaledReason$() {
  $n_Lmealorama_NotScaledReason$ = this;
  $t_Lmealorama_NotScaledReason$__NoServingCount = new $j_mealorama$002e$002dNot$002dScaled$002dReason$0024$0024anon$00241.$c_Lmealorama_NotScaledReason$$anon$1("NoServingCount", 0);
  $t_Lmealorama_NotScaledReason$__InvalidTargetServings = new $j_mealorama$002e$002dNot$002dScaled$002dReason$0024$0024anon$00241.$c_Lmealorama_NotScaledReason$$anon$1("InvalidTargetServings", 1);
  $t_Lmealorama_NotScaledReason$__AlreadyThatSize = new $j_mealorama$002e$002dNot$002dScaled$002dReason$0024$0024anon$00241.$c_Lmealorama_NotScaledReason$$anon$1("AlreadyThatSize", 2);
  $s_Lmealorama_NotScaledReason$__NoServingCount__Lmealorama_NotScaledReason();
  $s_Lmealorama_NotScaledReason$__InvalidTargetServings__Lmealorama_NotScaledReason();
  $s_Lmealorama_NotScaledReason$__AlreadyThatSize__Lmealorama_NotScaledReason();
}
export { $c_Lmealorama_NotScaledReason$ as $c_Lmealorama_NotScaledReason$ };
$p = $c_Lmealorama_NotScaledReason$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_NotScaledReason$;
/** @constructor */
function $h_Lmealorama_NotScaledReason$() {
}
export { $h_Lmealorama_NotScaledReason$ as $h_Lmealorama_NotScaledReason$ };
$h_Lmealorama_NotScaledReason$.prototype = $p;
var $d_Lmealorama_NotScaledReason$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_NotScaledReason$, "mealorama.NotScaledReason$", ({
  GC: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_NotScaledReason$ as $d_Lmealorama_NotScaledReason$ };
var $n_Lmealorama_NotScaledReason$;
function $m_Lmealorama_NotScaledReason$() {
  if ((!$n_Lmealorama_NotScaledReason$)) {
    $n_Lmealorama_NotScaledReason$ = new $c_Lmealorama_NotScaledReason$();
  }
  return $n_Lmealorama_NotScaledReason$;
}
export { $m_Lmealorama_NotScaledReason$ as $m_Lmealorama_NotScaledReason$ };
var $t_Lmealorama_NotScaledReason$__NoServingCount = null;
function $u_Lmealorama_NotScaledReason$__NoServingCount(x) {
  $t_Lmealorama_NotScaledReason$__NoServingCount = x;
}
export { $t_Lmealorama_NotScaledReason$__NoServingCount as $t_Lmealorama_NotScaledReason$__NoServingCount, $u_Lmealorama_NotScaledReason$__NoServingCount as $u_Lmealorama_NotScaledReason$__NoServingCount };
var $t_Lmealorama_NotScaledReason$__InvalidTargetServings = null;
function $u_Lmealorama_NotScaledReason$__InvalidTargetServings(x) {
  $t_Lmealorama_NotScaledReason$__InvalidTargetServings = x;
}
export { $t_Lmealorama_NotScaledReason$__InvalidTargetServings as $t_Lmealorama_NotScaledReason$__InvalidTargetServings, $u_Lmealorama_NotScaledReason$__InvalidTargetServings as $u_Lmealorama_NotScaledReason$__InvalidTargetServings };
var $t_Lmealorama_NotScaledReason$__AlreadyThatSize = null;
function $u_Lmealorama_NotScaledReason$__AlreadyThatSize(x) {
  $t_Lmealorama_NotScaledReason$__AlreadyThatSize = x;
}
export { $t_Lmealorama_NotScaledReason$__AlreadyThatSize as $t_Lmealorama_NotScaledReason$__AlreadyThatSize, $u_Lmealorama_NotScaledReason$__AlreadyThatSize as $u_Lmealorama_NotScaledReason$__AlreadyThatSize };
//# sourceMappingURL=mealorama.-Not-Scaled-Reason$.js.map
